export const DISCORD_LINK = 'https://discord.gg/ssSRkyUmsn';

export const TWITTER_LINK = 'https://twitter.com/setoros';

export const DOC_LINK = 'https://docs.setoros.com/';

export const HOMEPAGE_LINK = 'https://setoros.com/';

export const GITHUB_LINK = 'https://github.com/setoros-group/';
